module.exports = __webpack_public_path__ + "bg-hero_sale-mobile-top.jpg";